<template>
  <section class="container-fluid header-multi-bg" >
    <!-- DON'T CHANGE THE HEIGHT -->
    <b-container fluid class="header-multi" >
      <!-- CREATE A DYNAMIC BANNER USING THE ARRAY ITEMS -->
      <b-row fluid>
        <b-col class="d-none d-md-block d-lg-block p-0" md="5">
          <div :style="'height:100%;margin:0;' +
                'background-image:url('+items[item_id-1].image+');' +
                'background-size:cover;' +
                'background-position:center 0;'">
          </div>
        </b-col>
        <b-col md="7" class="text-left right-side">
          <div itemscope :itemtype="'https://schema.org/'+schema">
            <h1 class="title pt-2 pl-2 pr-2" itemprop="name" v-html="items[item_id-1].title+'<span class=\'dline_lg\'></span>'"></h1>
            <h2 class="subtitle pl-2 pb-2 mb-4" v-html="items[item_id-1].subtitle" itemprop="keywords"></h2>
              <div style="display:inline;margin-right:0.5rem;" class="pl-2 text-left" v-for="button in items[item_id-1].buttons" :key="button.id">
                <ButtonMeetingComponent class="pb-2 pt-2 lead"  v-if="button.type=='meeting'" :text="button.text" :variant="button.variant" />
                <ButtonContactComponent class="pb-2 pt-2 lead" v-else-if="button.type=='contact'" :text="button.text" :variant="button.variant" icon="chat" />
                <ButtonComponent v-else class="pb-2 pt-2 lead d-block d-sm-inline-block" :text="button.text" :icon="button.icon" :variant="button.variant" :href="button.link"></ButtonComponent>
              </div>
            <div class="pt-4">
              <div v-if="items[item_id-1].note!==undefined && items[item_id-1].note!==''" class="note">
                <b-icon class="text-muted mr-1" icon="info-square-fill"></b-icon>
                <label v-html="items[item_id-1].note"></label>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
      <!-- BUTTON TO CHANGE THE BANNER -->
      <b-row fluid class="text-center p-2" style="margin-top: -1rem" v-if="items.length > 1">
        <b-col>
            <b-icon class="ml-2" style="cursor:pointer" v-for="item in items" :key="item.id" :icon="item.id === item_id ? 'square-fill' : 'square' " variant="dark" @click="item_id = item.id" />
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
import ButtonComponent from '../buttons/ButtonComponent.vue'
import ButtonMeetingComponent from '../buttons/ButtonMeetingComponent.vue'
import ButtonContactComponent from '../buttons/ButtonContactComponent.vue'
export default {
  name: 'BannerMultiProductComponent',
  components: { ButtonContactComponent, ButtonMeetingComponent, ButtonComponent },
  props: {
    items: Array,
    schema: String,
    background: {
      type: String,
      default: '#fefefe'
    }
  },
  data () {
    return {
      item_id: 1,
      border: '#fefefe'
    }
  },
  methods: {
    transition () {
      setInterval(() => {
        this.item_id = this.item_id === this.$props.items.length ? 1 : this.item_id + 1
      }, 7000)
    },
    lightenHex (hex, percent) {
      // Elimina el # si existe
      hex = hex.replace(/^#/, '');

      // Convierte colores cortos (ej: #abc → #aabbcc)
      if (hex.length === 3) {
        hex = hex.split('').map(c => c + c).join('');
      }

      if (hex.length !== 6) {
        console.warn('Color no válido:', hex);
        return hex; // o algún valor por defecto
      }

      let r = parseInt(hex.substring(0, 2), 16);
      let g = parseInt(hex.substring(2, 4), 16);
      let b = parseInt(hex.substring(4, 6), 16);

      r = Math.min(255, Math.floor(r + (255 - r) * percent / 100));
      g = Math.min(255, Math.floor(g + (255 - g) * percent / 100));
      b = Math.min(255, Math.floor(b + (255 - b) * percent / 100));

      const toHex = x => x.toString(16).padStart(2, '0');

      return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
    }
  },
  mounted () {
    this.transition()
    this.border = this.lightenHex(this.background, 50)
  }
}
</script>
<style lang="scss" scoped>
@import "../../../systemico.ui/basic.scss";
  .header-multi-bg{
    background: v-bind( background );
    margin:0;
    padding: 0;
  }
  .header-multi-card{
    border-radius: 3rem;
    padding: 3rem;
    border:3px solid v-bind( border );
    height: auto;
    min-height: 32rem;
    max-width: 1280px;
    background: #fefefe;
  }
  .header-multi {
    height: auto;
    background: #fefefe;
    border-bottom: 0.5rem solid #FF8028;
    /**border-bottom-left-radius:25%;**/
    /**border-bottom-right-radius: 25%;**/
    overflow: hidden;
    .right-side{
      /**-webkit-box-shadow: -28px 0px 47px -12px rgba(0,0,0,0.40);
      -moz-box-shadow: -28px 0px 47px -12px rgba(0,0,0,0.40);
      box-shadow: -28px 0px 47px -12px rgba(0,0,0,0.40);**/
      padding-bottom: 2rem;
    }
    .title {
      margin-top: 1rem;
      font-size: calc(3rem + 1vw);
      line-height: calc(3.5rem + 1vw);
      font-weight: bold;
      color: #0b1c98;
      width: 90%;
    }

    .subtitle {
      font-size: calc(1.3rem + 1vw);;
      line-height: calc(1.5rem + 1vw);;
      color: #777777;
      width: 90%;
    }

    .note {
      font-size: 1.1rem;
      color: #444444;
      font-family: $font-quicksand;
      margin-left: 1rem;
    }

    /** MEDIA QUERY FOR VERTICAL IPAD **/
    @media (max-width: 1024px) {
      .title {
        margin-top: 1rem;
        font-size: calc(2.6rem + 1vw);
        line-height: calc(3rem + 1vw);
      }
      .subtitle {
        font-size: calc(1rem + 1vw);
        line-height: calc(1.2rem + 1vw);
      }
      .note {
        font-size: 0.8rem;
      }
    }
  }
</style>
